import { defineMessages } from 'react-intl';

const messages = defineMessages({
  mustAssignUnitToCertify: {
    id: 'App.GeneralAffordable.mustAssignUnitToCertify',
    defaultMessage: 'Must have an assigned unit to certify',
  },
  hasPendingApplicants: {
    id: 'App.GeneralAffordable.hasPendingApplicants',
    defaultMessage:
      'Cannot complete recertification until pending applicant is approved',
  },
  needsMoveInValues: {
    id: 'App.GeneralAffordable.NeedsMoveInValues',
    defaultMessage:
      "Must fill in the household's income and number of occupants at move-in on the Qualification History tab",
  },
  disabledAutoSendToTRACS: {
    id: 'App.GeneralAffordable.disabledAutoSendToTRACS',
    defaultMessage:
      'Auto-send to TRACS is disabled. The final 50059 or 50059A must be sent manually for processing.',
  },
  enabledAutoSendToTRACS: {
    id: 'App.GeneralAffordable.enabledAutoSendToTRACS',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Auto-send to TRACS is enabled. This automatically submits the final 50059 or 50059A for processing upon certification completion.',
  },
  certificationType: {
    id: 'App.GeneralAffordable.CertificationType',
    defaultMessage: 'Certification Type',
  },
  effectiveDateForUnitTransfer: {
    id: 'App.GeneralAffordable.EffectiveDateForUnitTransfer',
    defaultMessage: 'Effective Date of Transfer',
  },
  generate58Success: {
    id: 'App.GeneralAffordable.Generate58Success',
    defaultMessage: 'Generated 50058 Successfully',
  },
  generate58Error: {
    id: 'App.GeneralAffordable.Generate58Error',
    defaultMessage: 'There was an error generating the 50058',
  },
  ph50058CertificationErrorLogTitle: {
    id: 'App.GeneralAffordable.PH50058CertificationErrorLogTitle',
    defaultMessage: 'PH 50058 Certification Error Log',
  },
  ph50058CertificationErrorLogSubtitle: {
    id: 'App.GeneralAffordable.PH50058CertificationErrorLogSubtitle',
    defaultMessage:
      'The system has identified the following missing or incorrect data. ' +
      'Please correct/update the applicable entries before proceeding. ' +
      'Once complete, try to finalize the certification again.',
  },
  ph50058ValidationErrorTypeColumn: {
    id: 'App.GeneralAffordable.PH50058ValidationErrorTypeColumn',
    defaultMessage: 'Error Type',
  },
  ph50058ValidationFieldNumberColumn: {
    id: 'App.GeneralAffordable.PH50058ValidationFieldNumberColumn',
    defaultMessage: 'Field Number',
  },
  ph50058ValidationFieldNameColumn: {
    id: 'App.GeneralAffordable.PH50058ValidationFieldNameColumn',
    defaultMessage: 'Field Name',
  },
  ph50058ValidationHouseholdMemberColumn: {
    id: 'App.GeneralAffordable.PH50058ValidationHouseholdMemberColumn',
    defaultMessage: 'Household Member',
  },
  ph50058ValidationMemberFallback: {
    id: 'App.GeneralAffordable.PH50058ValidationMemberFallback',
    defaultMessage: 'Member {index}',
  },
  ph50058ValidationMessageColumn: {
    id: 'App.GeneralAffordable.PH50058ValidationMessageColumn',
    defaultMessage: 'Message',
  },
  generate59Success: {
    id: 'App.GeneralAffordable.Generate59Success',
    defaultMessage: 'Generated 59{use59a} Successfully',
  },
  generate59Error: {
    id: 'App.GeneralAffordable.Generate59Error',
    defaultMessage: 'There was an error generating the 59{use59a}',
  },
  transferCancelCertificationWarning: {
    id: 'App.GeneralAffordable.TransferCancelCertificationWarning',
    defaultMessage:
      'A transfer has been completed. You cannot cancel this certification.',
  },
  hudMoveOutCancelCertificationWarning: {
    id: 'App.GeneralAffordable.HudMoveOutCancelCertificationWarning',
    defaultMessage:
      'HUD Move-Out certifications must be completed. ' +
      'If you need to start another certification, please complete the MO first.',
  },
  certifyAndGenerate35608: {
    id: 'App.GeneralAffordable.CertifyAndGenerate35608',
    defaultMessage: 'Certify & Generate 3560-8',
  },
  generate35608Success: {
    id: 'App.GeneralAffordable.Generate35608Success',
    defaultMessage: 'Generated 3560-8 Successfully',
  },
  generate35608Error: {
    id: 'App.GeneralAffordable.Generate35608Error',
    defaultMessage: 'There was an error generating the 3560-8',
  },
  active: {
    id: 'App.GeneralAffordable.Active',
    defaultMessage: 'Active',
  },
  reopened: {
    id: 'App.GeneralAffordable.Reopened',
    defaultMessage: 'Re-opened',
  },
  modified: {
    id: 'App.GeneralAffordable.Modified',
    defaultMessage: 'Modified',
  },
  complete: {
    id: 'App.GeneralAffordable.Complete',
    defaultMessage: 'Complete',
  },
  correction: {
    id: 'App.GeneralAffordable.Correction',
    defaultMessage: 'Correction',
  },
  generateRDLease: {
    id: 'App.GeneralAffordable.GenerateRDLease',
    defaultMessage: 'Generate RD Lease',
  },
  miCorrectionEffectiveDateWarning: {
    id: 'App.GeneralAffordable.MICorrectionEffectiveDateWarning',
    defaultMessage:
      'Changing the MI effective date may result in retroactive adjustments to the ledger.',
  },
  homeRecertType: {
    id: 'App.GeneralAffordable.HomeRecertType',
    defaultMessage: 'HOME Recert Type',
  },
  homeRecertTypeRequired: {
    id: 'App.GeneralAffordable.HomeRecertTypeRequired',
    defaultMessage: 'HOME Recert Type is required.',
  },
  generateHUDLease: {
    id: 'App.GeneralAffordable.GenerateHULease',
    defaultMessage: 'Generate HUD Lease',
  },
  generateHUD202Lease: {
    id: 'App.GeneralAffordable.GenerateHUD202Lease',
    defaultMessage: 'Generate 202 PRAC Lease',
  },
  generate811Lease: {
    id: 'App.GeneralAffordable.Generate811Lease',
    defaultMessage: 'Generate 811 Lease',
  },
  hud59: {
    id: 'App.GeneralAffordable.HUD59',
    defaultMessage: '50059',
  },
  hud59A: {
    id: 'App.GeneralAffordable.HUD59A',
    defaultMessage: '50059A',
  },
  cert58: {
    id: 'App.GeneralAffordable.Cert58',
    defaultMessage: '50058',
  },
  startedIncompleteTab: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.StartedIncompleteTab',
    defaultMessage: 'Started / Incomplete',
  },
  reopenedCorrectionStartedTab: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.ReopenedCorrectionStartedTab',
    defaultMessage: 'Reopened / Correction Started',
  },
  completedTab: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.CompletedTab',
    defaultMessage: 'Completed',
  },
  certificationStatusTabsAriaLabel: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.CertificationStatusTabsAriaLabel',
    defaultMessage: 'Certification status tabs',
  },
  noCertificationsStarted: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.NoCertificationsStarted',
    defaultMessage: 'No Certifications Started',
  },
  noReopenedCertifications: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.NoReopenedCertifications',
    defaultMessage: 'No Certifications Reopened or Corrections Started',
  },
  noCompletedCertifications: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.NoCompletedCertifications',
    defaultMessage: 'No Completed Certifications',
  },
  noAvailableCertificationsMessage: {
    id: 'App.GeneralAffordable.GeneralAffordableStatusTab.NoAvailableCertificationsMessage',
    defaultMessage: 'There are no available certifications to show',
  },
  hudNotices: {
    id: 'App.GeneralAffordable.HUD59Notices',
    defaultMessage: '50059 + Notices',
  },
  certifyAndGenerate58: {
    id: 'App.GeneralAffordable.CertifyAndGenerate58',
    defaultMessage: 'Certify & Generate 50058',
  },
  certifyAndGenerate59: {
    id: 'App.GeneralAffordable.CertifyAndGenerate59',
    defaultMessage: 'Certify & Generate 50059',
  },
  certifyAndGenerate59A: {
    id: 'App.GeneralAffordable.CertifyAndGenerate59A',
    defaultMessage: 'Certify & Generate 50059A',
  },
  uploadSignedDocumentSuccess: {
    id: 'App.GeneralAffordable.UploadSignedDocumentSuccess',
    defaultMessage: 'Successfully Uploaded Signed Document',
  },
  notDetermined: {
    id: 'App.GeneralAffordable.NotDetermined',
    defaultMessage: 'Not Determined',
  },
  doesNotQualify: {
    id: 'App.GeneralAffordable.DoesNotQualify',
    defaultMessage: 'Does Not Qualify',
  },
  citizenStatus: {
    id: 'App.GeneralAffordable.CitizenStatus',
    defaultMessage: 'Citizen Status',
  },
  deductions: {
    id: 'App.GeneralAffordable.Deductions',
    defaultMessage: 'Deductions',
  },
  communityService: {
    id: 'App.GeneralAffordable.CommunityService',
    defaultMessage: 'Community Service',
  },
  saveSummary: {
    id: 'App.GeneralAffordable.SaveSummary',
    defaultMessage: 'Save Summary',
  },
  householdSummary: {
    id: 'App.GeneralAffordable.HouseholdSummary',
    defaultMessage: 'Household Summary',
  },
  saveSummarySuccess: {
    id: 'App.GeneralAffordable.SaveSummarySuccess',
    defaultMessage: 'Household Summary saved successfully',
  },
  unableToUpdateCommunityService: {
    id: 'App.GeneralAffordable.UnableToUpdateCommunityService',
    defaultMessage: 'Unable to update Community Service statuses',
  },
  communityServiceUpdatedSuccess: {
    id: 'App.GeneralAffordable.CommunityServiceUpdatedSuccess',
    defaultMessage: 'Community Service details updated successfully.',
  },
  communityServiceRequirement: {
    id: 'App.GeneralAffordable.CommunityServiceRequirement',
    defaultMessage: 'Community Service Requirement',
  },
  formsLibraryTitle: {
    id: 'App.GeneralAffordable.FormsLibrary',
    defaultMessage: 'Forms Library',
  },
  formLibraryDescription: {
    id: 'App.GeneralAffordable.FormLibraryDescription',
    defaultMessage:
      'Select any document you need to add to required documents list.',
  },
  uploadPacketTitle: {
    id: 'App.GeneralAffordable.UploadPacketTitle',
    defaultMessage: 'Compliance Packet Upload',
  },
  upload59ATitle: {
    id: 'App.GeneralAffordable.Upload59ATitle',
    defaultMessage: 'Upload Signed Document',
  },
  startACertificationTitle: {
    id: 'App.GeneralAffordable.StartACertificationTitle',
    defaultMessage: 'Certification Type: {certType}',
  },
  specialNeedsTitle: {
    id: 'App.GeneralAffordable.SpecialNeedsTitle',
    defaultMessage: 'Special Needs',
  },
  citizenStatusTitle: {
    id: 'App.GeneralAffordable.CitizenStatusTitle',
    defaultMessage: 'Citizen Statuses',
  },
  deductionsTitle: {
    id: 'App.GeneralAffordable.DeductionsTitle',
    defaultMessage: 'Deductions',
  },
  communityServiceTitle: {
    id: 'App.GeneralAffordable.CommunityServiceTitle',
    defaultMessage: 'Community Service',
  },
  overrideQualificationTitle: {
    id: 'App.GeneralAffordable.OverrideQualificationTitle',
    defaultMessage: 'Reason for Overriding Qualification Test',
  },
  createGrossRentCertificationTitle: {
    id: 'App.GeneralAffordable.CreateGrossRentCertificationTitle',
    defaultMessage: 'Gross Rent Certification',
  },
  terminateAndCreate: {
    id: 'App.GeneralAffordable.TerminateAndCreate',
    defaultMessage: 'Terminate & Create',
  },
  completePacketUpload: {
    id: 'App.GeneralAffordable.CompletePacketUpload',
    defaultMessage: 'Complete Packet Upload',
  },
  complianceDocumentDeleteConfirmationMessage: {
    id: 'App.GeneralAffordable.ComplianceDocumentConfirmationMessage',
    defaultMessage: 'Are you sure you want to delete this document?',
  },
  completeCertificationConfirmationMessage: {
    id: 'App.GeneralAffordable.CompleteCertificationConfirmationMessage',
    defaultMessage: 'Are you sure you want to complete this certification?',
  },
  completeReopenedCertificationWarningMessage: {
    id: 'App.GeneralAffordable.CompleteReopenedCertificationWarningMessage',
    defaultMessage:
      'Completing this certification will replace all existing certification ' +
      'data with the updated information.',
  },
  completeTerminationAutoVoidWarningMessage: {
    id: 'App.GeneralAffordable.CompleteTerminationAutoVoidWarningMessage',
    defaultMessage:
      'This household has completed certifications effective on or after ' +
      'this termination. Those certifications will now be voided with this ' +
      'termination going into effect.',
  },
  completeMoveOutAutoVoidWarningMessage: {
    id: 'App.GeneralAffordable.CompleteMoveOutAutoVoidWarningMessage',
    defaultMessage:
      'This household has completed certifications effective on or after ' +
      'this move-out. Those certifications will now be voided with this ' +
      'move-out going into effect.',
  },
  completeTerminationAutoVoidCertItem: {
    id: 'App.GeneralAffordable.CompleteTerminationAutoVoidCertItem',
    defaultMessage: '{certificationType} effective {effectiveDate}',
  },
  leaveWithoutSavingWarningMessage: {
    id: 'App.GeneralAffordable.LeaveWithoutSavingWarningMessage',
    defaultMessage: 'Are you sure you want to leave without saving?',
  },
  signatureDatesTitle: {
    id: 'App.GeneralAffordable.SignatureDatesTitle',
    defaultMessage: 'Signature Dates',
  },
  saveSignatureDates: {
    id: 'App.GeneralAffordable.SaveSignatureDates',
    defaultMessage: 'Save Signature Dates',
  },
  ownerSignatureDateRequired: {
    id: 'App.GeneralAffordable.OwnerSignatureDateRequired',
    defaultMessage: 'Owner signature date is required',
  },
  residentSignatureDateRequired: {
    id: 'App.GeneralAffordable.ResidentSignatureDateRequired',
    defaultMessage: 'Resident signature date is required',
  },
  signatureDatesCannotBeFuture: {
    id: 'App.GeneralAffordable.SignatureDatesCannotBeFuture',
    defaultMessage: 'Signature dates cannot be in the future',
  },
  savedSignatureDatesSuccessfully: {
    id: 'App.GeneralAffordable.SavedSignatureDatesSuccessfully',
    defaultMessage: 'Saved Signature Dates Successfully',
  },
  overage: {
    id: 'App.GeneralAffordable.Overage',
    defaultMessage: 'Overage',
  },
  surcharge: {
    id: 'App.GeneralAffordable.Surcharge',
    defaultMessage: 'Surcharge',
  },
  changeToMarketRate: {
    id: 'App.GeneralAffordable.AssistanceDetails.ChangeToMarketRent',
    defaultMessage: 'Change to Market Rate',
  },
  assistanceDetails: {
    id: 'App.GeneralAffordable.AssistanceDetails',
    defaultMessage: 'Assistance Details',
  },
  generateAssistanceDetails: {
    id: 'App.GeneralAffordable.GenerateAssistanceDetails',
    defaultMessage: 'Generate Assistance Details',
  },
  customProgram: {
    id: 'App.GeneralAffordable.CustomProgram',
    defaultMessage: '{programName} Program',
  },
  residentRent: {
    id: 'App.GeneralAffordable.ResidentRent',
    defaultMessage: 'Resident Rent',
  },
  assistancePayment: {
    id: 'App.GeneralAffordable.AssistancePayment',
    defaultMessage: 'Assistance Payment',
  },
  utilityAllowance: {
    id: 'App.GeneralAffordable.UtilityAllowance',
    defaultMessage: 'Utility Allowance',
  },
  utilityReimbursement: {
    id: 'App.GeneralAffordable.UtilityReimbursement',
    defaultMessage: 'Utility Reimbursement',
  },
  TTPbeforeOverrideValidation: {
    id: 'App.GeneralAffordable.TTPbeforeOverrideValidation',
    defaultMessage:
      'Enter the calculated resident rent in the assistance details before completing the TTP Override Amount.',
  },
  requiredDocumentationTitle: {
    id: 'App.GeneralAffordable.RequiredDocumentationTitle',
    defaultMessage: 'Required Documentation',
  },
  documentName: {
    id: 'App.GeneralAffordable.DocumentName',
    defaultMessage: 'Document Name',
  },
  householdMembers: {
    id: 'App.GeneralAffordable.HouseholdMembers',
    defaultMessage: 'Household Member(s)',
  },
  documentStatus: {
    id: 'App.GeneralAffordable.DocumentStatus',
    defaultMessage: 'Document Status',
  },
  pendingSignature: {
    id: 'App.GeneralAffordable.PendingSignature',
    defaultMessage: 'Pending Signature(s)',
  },
  sentForSignature: {
    id: 'App.GeneralAffordable.SentForSignature',
    defaultMessage: 'Sent for Signature(s)',
  },
  completedStatus: {
    id: 'App.GeneralAffordable.CompletedStatus',
    defaultMessage: 'Complete',
  },
  voidStatus: {
    id: 'App.GeneralAffordable.VoidStatus',
    defaultMessage: 'Void',
  },
  addForm: {
    id: 'App.GeneralAffordable.AddForm',
    defaultMessage: 'Add Form',
  },
  affordableQualificationSaved: {
    id: 'App.GeneralAffordable.AffordableQualificationSaved',
    defaultMessage: 'Affordable Qualification Saved',
  },
  requiredDocumentationDescription: {
    id: 'App.GeneralAffordable.RequiredDocumentationDescription',
    defaultMessage:
      'Track all forms tied to the certification. Review, correct, or add forms ' +
      'as needed. This section is available once an applicant has completed their ' +
      'Portal application. If any required form is missing, add more in Document ' +
      'Actions > Add Forms. When every form is marked as complete, you can ' +
      'generate the affordable packet.',
  },
  searchPlaceholder: {
    id: 'App.GeneralAffordable.SearchPlaceholder',
    defaultMessage: 'Search...',
  },
  formInstancesCreated: {
    id: 'App.GeneralAffordable.FormInstancesCreated',
    defaultMessage: 'Forms added successfully',
  },
  formInstanceDeleted: {
    id: 'App.GeneralAffordable.FormInstanceDeleted',
    defaultMessage: 'Form removed successfully',
  },
  householdMembersLockedTooltip: {
    id: 'App.GeneralAffordable.HouseholdMembersLockedTooltip',
    defaultMessage:
      'Household members cannot be edited after the form has been sent for signature or completed',
  },
  formInstanceSignersUpdated: {
    id: 'App.GeneralAffordable.FormInstanceSignersUpdated',
    defaultMessage: 'Household members updated successfully',
  },
  documents: {
    id: 'App.GeneralAffordable.Documents',
    defaultMessage: 'Documents',
  },
  source: {
    id: 'App.GeneralAffordable.Source',
    defaultMessage: 'Source',
  },
  type: {
    id: 'App.GeneralAffordable.Type',
    defaultMessage: 'Type',
  },
  download: {
    id: 'App.GeneralAffordable.Download',
    defaultMessage: 'Download',
  },
  sendForSignatureTooltip: {
    id: 'App.GeneralAffordable.SendForSignatureTooltip',
    defaultMessage: 'Send for Signature',
  },
  sendForSignatureDisabledTooltip: {
    id: 'App.GeneralAffordable.SendForSignatureDisabledTooltip',
    defaultMessage: 'Assign household members before sending for signature',
  },
  sendForSignatureSuccess: {
    id: 'App.GeneralAffordable.SendForSignatureSuccess',
    defaultMessage: '{formName} successfully sent for signature.',
  },
  sendForSignatureError: {
    id: 'App.GeneralAffordable.SendForSignatureError',
    defaultMessage: 'There was an error sending the form for signature',
  },
  deleteFormTooltip: {
    id: 'App.GeneralAffordable.DeleteFormTooltip',
    defaultMessage: 'Delete Form',
  },
  deleteFormDisabledTooltip: {
    id: 'App.GeneralAffordable.DeleteFormDisabledTooltip',
    defaultMessage:
      'Voided forms and forms on a read-only certification cannot be deleted',
  },
  sendFormNotPendingTooltip: {
    id: 'App.GeneralAffordable.SendFormNotPendingTooltip',
    defaultMessage: 'Form has already been sent for signature',
  },
  uploadFormTooltip: {
    id: 'App.GeneralAffordable.UploadFormTooltip',
    defaultMessage: 'Upload Signed Document',
  },
  uploadFormDisabledTooltip: {
    id: 'App.GeneralAffordable.UploadFormDisabledTooltip',
    defaultMessage:
      'Assign household members before uploading a signed document',
  },
  uploadAlreadyUploaded: {
    id: 'App.GeneralAffordable.UploadAlreadyUploaded',
    defaultMessage:
      'A signed document has already been uploaded. Unable to upload additional documents.',
  },
  uploadDisabledNoHousehold: {
    id: 'App.GeneralAffordable.UploadDisabledNoHousehold',
    defaultMessage: 'Assign household members before uploading',
  },
  uploadFormError: {
    id: 'App.GeneralAffordable.UploadFormError',
    defaultMessage: 'There was an error uploading the form',
  },
  downloadFormError: {
    id: 'App.GeneralAffordable.DownloadFormError',
    defaultMessage: 'There was an error downloading the form',
  },
  RDLeaseButtonOptionTextStandard: {
    id: 'App.GeneralAffordable.RD.GenerateLease.Option.Text.Standard',
    defaultMessage: 'RD Lease',
  },
  RDLeaseButtonOptionTextRRAP: {
    id: 'App.GeneralAffordable.RD.GenerateLease.Option.Text.RRAP',
    defaultMessage: 'RD Lease (RRAP)',
  },
  RDLeaseButtonOptionTextRenewalStandard: {
    id: 'App.GeneralAffordable.RD.GenerateLease.Option.Text.RenewalStandard',
    defaultMessage: 'RD Renewal Lease',
  },
  RDLeaseButtonOptionTextRenewalRRAP: {
    id: 'App.GeneralAffordable.RD.GenerateLease.Option.Text.RenewalRRAP',
    defaultMessage: 'RD Renewal Lease (RRAP)',
  },
  backgroundAtAdmission: {
    id: 'App.GeneralAffordable.BackgroundAtAdmission',
    defaultMessage: 'Background at Admission',
  },
  saveBackgroundAtAdmission: {
    id: 'App.GeneralAffordable.SaveBackgroundAtAdmission',
    defaultMessage: 'Save Background',
  },
  saveBackgroundAtAdmissionSuccess: {
    id: 'App.GeneralAffordable.SaveBackgroundAtAdmissionSuccess',
    defaultMessage: 'Background at Admission saved successfully',
  },
  saveBackgroundAtAdmissionError: {
    id: 'App.GeneralAffordable.SaveBackgroundAtAdmissionError',
    defaultMessage: 'Unable to save Background at Admission details',
  },
  deleteFormInstanceTitle: {
    id: 'App.GeneralAffordable.DeleteFormInstanceTitle',
    defaultMessage: 'Delete Form',
  },
  deleteFormInstanceConfirmation: {
    id: 'App.GeneralAffordable.DeleteFormInstanceConfirmation',
    defaultMessage:
      'Are you sure you want to delete the following document from the Required Documents table?',
  },
  sendForSignatureConfirmTitle: {
    id: 'App.GeneralAffordable.SendForSignatureConfirmTitle',
    defaultMessage: 'Send for Signature',
  },
  sendForSignatureConfirmDescription: {
    id: 'App.GeneralAffordable.SendForSignatureConfirmDescription',
    defaultMessage:
      'Please review and confirm that all household members listed are correct ' +
      'and their associated email addresses are valid. Select "Confirm" ' +
      'to send this form out for signatures.',
  },
  emailValidationValid: {
    id: 'App.GeneralAffordable.EmailValidationValid',
    defaultMessage: 'Valid',
  },
  emailValidationInvalid: {
    id: 'App.GeneralAffordable.EmailValidationInvalid',
    defaultMessage: 'Invalid',
  },
  emailValidationInvalidBanner: {
    id: 'App.GeneralAffordable.EmailValidationInvalidBanner',
    defaultMessage:
      'Some email addresses are invalid. Please update the email addresses and try again.',
  },
  emailValidationErrorBanner: {
    id: 'App.GeneralAffordable.EmailValidationErrorBanner',
    defaultMessage:
      'There was an error validating email addresses. Please try again.',
  },
  emailValidationRetry: {
    id: 'App.GeneralAffordable.EmailValidationRetry',
    defaultMessage: 'Retry',
  },
  emailValidationValidating: {
    id: 'App.GeneralAffordable.EmailValidationValidating',
    defaultMessage: 'Validating email addresses...',
  },
  sendForSignatureConfirmButton: {
    id: 'App.GeneralAffordable.SendForSignatureConfirmButton',
    defaultMessage: 'Confirm',
  },
  signerTableHeaderName: {
    id: 'App.GeneralAffordable.SignerTableHeaderName',
    defaultMessage: 'Name',
  },
  signerTableHeaderEmail: {
    id: 'App.GeneralAffordable.SignerTableHeaderEmail',
    defaultMessage: 'Email',
  },
  signerTableHeaderValid: {
    id: 'App.GeneralAffordable.SignerTableHeaderValid',
    defaultMessage: 'Valid',
  },
  cancelButton: {
    id: 'App.GeneralAffordable.CancelButton',
    defaultMessage: 'Cancel',
  },
  closeButton: {
    id: 'App.GeneralAffordable.CloseButton',
    defaultMessage: '✕',
  },
  makeCorrection: {
    id: 'App.GeneralAffordable.MakeCorrection',
    defaultMessage: 'Make Correction',
  },
  makeCorrectionDisabledTooltip: {
    id: 'App.GeneralAffordable.MakeCorrectionDisabledTooltip',
    defaultMessage:
      'Corrections can only be made to forms that have been sent for signature.',
  },
  correctionSuccess: {
    id: 'App.GeneralAffordable.CorrectionSuccess',
    defaultMessage:
      'Correction applied. Form has been reset to Pending Signature.',
  },
  makeCorrectionConfirmTitle: {
    id: 'App.GeneralAffordable.MakeCorrectionConfirmTitle',
    defaultMessage: 'Make Correction',
  },
  makeCorrectionConfirmBody: {
    id: 'App.GeneralAffordable.MakeCorrectionConfirmBody',
    defaultMessage: 'Are you sure you want to make changes to this form?',
  },
  makeCorrectionConfirmDescription: {
    id: 'App.GeneralAffordable.MakeCorrectionConfirmDescription',
    defaultMessage:
      'This will reset the form to Pending Signature, allow you to update ' +
      'household members, and require the form to be sent for signatures again.',
  },
  saveCorrection: {
    id: 'App.GeneralAffordable.SaveCorrections',
    defaultMessage: 'Save Correction',
  },
  saveCorrectionSuccess: {
    id: 'App.GeneralAffordable.SaveCorrectionSuccess',
    defaultMessage: 'Correction information saved successfully',
  },
  saveCorrectionError: {
    id: 'App.GeneralAffordable.SaveCorrectionError',
    defaultMessage: 'Failed to save correction information',
  },
  corrections: {
    id: 'App.GeneralAffordable.Corrections',
    defaultMessage: 'Corrections',
  },
  saveDetails: {
    id: 'App.GeneralAffordable.SaveDetails',
    defaultMessage: 'Save Details',
  },
  tracsSubmissionDateLabel: {
    id: 'App.GeneralAffordable.CertificationHeader.TracsSubmissionDateLabel',
    defaultMessage: 'TRACS Submission Date',
  },
  tracsSubmissionDateTooltip: {
    id: 'App.GeneralAffordable.CertificationHeader.TracsSubmissionDateTooltip',
    defaultMessage: 'If blank, certification has not been submitted.',
  },
  // Shown when hudTenantEvent.grVoucherSuppression is present. Copy approved verbatim
  // in the UX story -- do not edit without design.
  tracsSubmissionDateSuppressedTooltip: {
    id: 'App.GeneralAffordable.CertificationHeader.TracsSubmissionDateSuppressedTooltip',
    defaultMessage:
      'This GR was excluded from the Voucher because another Certification on the same ' +
      'voucher already includes the updated rent information for this household.',
  },
  anticipatedVoucherDateTooltip: {
    id: 'App.GeneralAffordable.CertificationHeader.anticipatedVoucherDateTooltip',
    defaultMessage: 'Determines which Voucher this certification will be on.',
  },
  avdVoucherAwareTooltip: {
    id: 'App.GeneralAffordable.CertificationHeader.avdVoucherAwareTooltip',
    defaultMessage:
      'Determines which Voucher this certification will be on. ' +
      'Dates for Vouchers already approved will not be accepted.',
  },
  avdApprovedVoucherError: {
    id: 'App.GeneralAffordable.CertificationHeader.avdApprovedVoucherError',
    defaultMessage:
      'This Voucher has already been approved. Please select the next ' +
      'Voucher month-year that does not have an approved Voucher.',
  },
  editAnticipatedVoucherDateNoPermissionTooltip: {
    id: 'App.GeneralAffordable.CertificationHeader.editAnticipatedVoucherDateNoPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  floorPlanNotAvailable: {
    id: 'App.GeneralAffordable.CertificationHeader.floorPlanNotAvailable',
    defaultMessage: 'Floor Plan Not Available',
  },
  fss: {
    id: 'App.GeneralAffordable.FSS',
    defaultMessage: 'Family Self Sufficiency (FSS)',
  },
  saveFamilySelfSufficiency: {
    id: 'App.GeneralAffordable.SaveFamilySelfSufficiency',
    defaultMessage: 'Save FSS',
  },
  saveFamilySelfSufficiencySuccess: {
    id: 'App.GeneralAffordable.SaveFamilySelfSufficiencySuccess',
    defaultMessage: 'Family Self-Sufficiency details saved successfully',
  },
  saveFamilySelfSufficiencyError: {
    id: 'App.GeneralAffordable.SaveFamilySelfSufficiencyError',
    defaultMessage: 'Unable to save Family Self-Sufficiency details',
  },
  downloadAllCompletedFormsError: {
    id: 'App.GeneralAffordable.DownloadAllCompletedFormsError',
    defaultMessage: 'There was an error downloading the completed forms',
  },
  downloadAllCompletedForms: {
    id: 'App.GeneralAffordable.DownloadAllCompletedForms',
    defaultMessage: 'Download Completed Forms',
  },
  noCompletedForms: {
    id: 'App.GeneralAffordable.NoCompletedForms',
    defaultMessage:
      'No forms have been completed. Complete a form to download all completed forms.',
  },
  custodyModalTitle: {
    id: 'App.GeneralAffordable.CustodyModalTitle',
    defaultMessage: 'Joint Custody Dependent',
  },
  custodyModalSubtitle: {
    id: 'App.GeneralAffordable.CustodyModalSubtitle',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Select the correct Joint Custody Dependent options so that the HUD 50059 certification Special Status Code and eligibility allowances apply correctly.',
  },
  miniApplication: {
    id: 'App.GeneralAffordable.MiniApplication',
    defaultMessage: 'Mini Application',
  },
  recertApplication: {
    id: 'App.GeneralAffordable.RecertApplication',
    defaultMessage: 'Recert Application',
  },
  jointCustodyYes50Allowance: {
    id: 'App.GeneralAffordable.JointCustodyYes50Allowance',
    defaultMessage: 'Yes, 50% or more - Dependent & Child Care Allowance apply',
  },
  jointCustodyYes50CountOnly: {
    id: 'App.GeneralAffordable.JointCustodyYes50CountOnly',
    defaultMessage:
      'Yes, 50% or more - Count only for Unit Size & Income Limitations',
  },
  jointCustodyYesLessThan50: {
    id: 'App.GeneralAffordable.JointCustodyYesLessThan50',
    defaultMessage: 'Yes, less than 50%',
  },
  openHUDGrossRentBanner: {
    id: 'App.GeneralAffordable.OpenHUDGrossRentBanner',
    defaultMessage:
      'There is an open Gross Rent certification for this household. ' +
      'For any certification with an effective date after the GR, ' +
      'updated amounts will not reflect until the GR is completed.',
  },
  startCertificationOpenGrossRentTooltip: {
    id: 'App.GeneralAffordable.StartCertificationOpenGrossRentTooltip',
    defaultMessage:
      'There is an open Gross Rent Certification for this household. ' +
      'Go to Manage Gross Rents > Gross Rent Certifications to manage.',
  },
  startCertificationNoEligibleGrossRentTooltip: {
    id: 'App.GeneralAffordable.StartCertificationNoEligibleGrossRentTooltip',
    defaultMessage:
      'There are no eligible Gross Rent certifications to start for this household',
  },
  openHUDGrossRentBannerUpdated: {
    id: 'App.GeneralAffordable.OpenHUDGrossRentBannerUpdated',
    defaultMessage:
      'There is an open Gross Rent Certification for this household. ' +
      "Certifications with an Effective Date on or after the Gross Rent's " +
      'Effective Date cannot be completed until the Gross Rent ' +
      'Certification is completed. ' +
      'Updated amounts will not be reflected in affected certifications ' +
      'until the Gross Rent Certification is completed.',
  },
  completeCertificationUpdatedDisabledTooltip: {
    id: 'App.GeneralAffordable.CompleteCertificationButton.UpdatedDisabledTooltip',
    defaultMessage:
      'Ensure the Compliance Approval Status is Approved, all required fields ' +
      'are completed, and any impacting Gross Rent Certifications have been ' +
      'completed.',
  },
  completeCertificationAssistanceNotCurrentTooltip: {
    id: 'App.GeneralAffordable.CompleteCertificationButton.AssistanceNotCurrentTooltip',
    defaultMessage:
      'Certify and generate the 50059/50059A before completing the ' +
      'certification.',
  },
  completeCertificationAssistanceOutOfDateTooltip: {
    id: 'App.GeneralAffordable.CompleteCertificationButton.AssistanceOutOfDateTooltip',
    defaultMessage:
      'The assistance details changed after they were generated. Generate ' +
      'Assistance Details, then certify and generate the 50059/50059A before ' +
      'completing the certification.',
  },
  nextRecertificationDate: {
    id: 'App.GeneralAffordable.NextRecertificationDate',
    defaultMessage: 'Next Recertification Date',
  },
  noPermissionAction: {
    id: 'App.GeneralAffordable.NoPermissionAction',
    defaultMessage: 'You do not have permission to modify this certification.',
  },
  complianceDocumentsViewDocument: {
    id: 'App.GeneralAffordable.ComplianceDocuments.ViewDocument',
    defaultMessage: 'View',
  },
  complianceDocumentsNoPermissionTooltip: {
    id: 'App.GeneralAffordable.ComplianceDocuments.NoPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  reviewedByComplianceDocumentTypeNoPermissionTooltip: {
    id: 'App.GeneralAffordable.ComplianceDocuments.ReviewedByComplianceDocumentTypeNoPermissionTooltip',
    defaultMessage: 'You do not have permission to select this status.',
  },
  citizenEligibilityAllEligibleInvalid: {
    id: 'App.GeneralAffordable.CitizenEligibilityAllEligibleInvalid',
    defaultMessage:
      'Cannot select option E when a household member has PV citizen status.',
  },
  citizenEligibilityFullAssistanceInvalid: {
    id: 'App.GeneralAffordable.CitizenEligibilityFullAssistanceInvalid',
    defaultMessage:
      'Cannot select option F when a household member has a citizen status other than EC, EN, or PV.',
  },
  // ENG-30153: ConvertCertificationModal copy is verbatim from the approved mockup (supersedes the
  // ticket's "Confirm Certification Conversion" wording, OQ10).
  convertCertificationModalTitle: {
    id: 'App.GeneralAffordable.ConvertCertificationModalTitle',
    defaultMessage: 'Convert Certifications',
  },
  convertCertificationModalBody: {
    id: 'App.GeneralAffordable.ConvertCertificationModalBody',
    defaultMessage:
      'Are you sure you want to convert this certification? All applicable ' +
      'information from the current certification will be copied to the ' +
      'new certification type.',
  },
  convertCertificationCancel: {
    id: 'App.GeneralAffordable.ConvertCertificationCancel',
    defaultMessage: 'Cancel',
  },
  convertCertificationConfirm: {
    id: 'App.GeneralAffordable.ConvertCertificationConfirm',
    defaultMessage: 'Confirm',
  },
  convertCertificationSuccess: {
    id: 'App.GeneralAffordable.ConvertCertificationSuccess',
    defaultMessage: 'Successfully converted certification.',
  },
  effectiveDateMatchesRecertDueDate: {
    id: 'App.GeneralAffordable.EffectiveDateMatchesRecertDueDate',
    defaultMessage: "Date matches household's Recert Due Date.",
  },
  startInterimRecertDueDateBanner: {
    id: 'App.GeneralAffordable.StartInterimRecertDueDateBanner',
    defaultMessage:
      "This household's Recert Due Date matches this Effective Date. Please cancel and start a Recert.",
  },
  editInterimRecertDueDateBanner: {
    id: 'App.GeneralAffordable.EditInterimRecertDueDateBanner',
    defaultMessage:
      // eslint-disable-next-line max-len
      "This household's Recert Due Date matches this Effective Date. Please cancel this certification and start a Recert.",
  },
  // Convert MenuButton label + no-permission tooltip. Defined here (an extracted messages.js) rather
  // than CertificationHeader.messages.js, which the `./src/**/messages.js` extract glob does not pick
  // up, so these stay translatable. (ENG-30153)
  convertCertification: {
    id: 'App.GeneralAffordable.ConvertCertification',
    defaultMessage: 'Convert Certification',
  },
  noPermissionConvertAction: {
    id: 'App.GeneralAffordable.NoPermissionConvertAction',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  // Not in ComplianceApproval.messages.js: the extractor glob is `src/**/messages.js`, so a
  // dotted messages file never reaches the locale JSON and stays English-only. (ENG-28274)
  noUnitComplianceApprovalTooltip: {
    id: 'App.GeneralAffordable.ComplianceApproval.NoUnitTooltip',
    defaultMessage:
      'Applicant must have a unit assigned to update the Compliance Approval status.',
  },
});

export default messages;
